import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class HoneypotSetService {
	
  async getHoneypotSetById(honeypotSetId: string) {
	return await Api().get(`${API_URL}/honeypotSet/${honeypotSetId}`, { headers:  authHeader() as any });      
  }
  async find(term: string) {
    return await Api().get(`${API_URL}/honeypotSet/find?text=${term}%`, { headers:  authHeader() as any });      
  }

  async updateHoneypotSet(honeypotSet: any) {
    return await Api().put(`${API_URL}/honeypotSet/${honeypotSet.id}`, honeypotSet, 
    { method: 'PUT',
      headers:  authHeader() as any });      
  }

  async createHoneypotSet(honeypotSet: any) {
    return await Api().post(`${API_URL}/honeypotSet/`, honeypotSet, 
    { method: 'POST',
      headers:  authHeader() as any });      
  }

  async deleteHoneypotSet(honeypotSet: any) {
    return await Api().delete(`${API_URL}/honeypotSet/${honeypotSet.id}`, 
    { method: 'DELETE',
      headers:  authHeader() as any });      
  }  

  async getMetadata() {
    return await Api().get(`${API_URL}/honeypotSet/metadata`, { headers:  authHeader() as any });      
  }
}

export default new HoneypotSetService();